import { TeButton } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';

import { AgreementCreationType, StepEnum } from '../../../types/customer-modal.types';

interface CreateCustomerStepActionsProps {
  onClose: (shouldUpdate: boolean) => void;
  isPending: boolean;
  isNextStepDisabled: boolean;
  currentStep: StepEnum;
  totalSteps: number;
  onPreviousStep: (key: StepEnum) => void;
  onNextStep: (key: StepEnum) => void;
  onSubmit: () => void;
  creationType: AgreementCreationType;
}

function CreateCustomerStepActions({
  onClose,
  isPending,
  currentStep,
  totalSteps,
  isNextStepDisabled,
  onPreviousStep,
  onNextStep,
  onSubmit,
  creationType,
}: CreateCustomerStepActionsProps) {
  const { t } = useTranslation();
  return (
    <>
      <TeButton
        slot="tertiary"
        text={t('cancel', { ns: 'common' })}
        variant="neutral"
        teclick={() => onClose(false)}
        size="s"
        disabled={isPending}
      />
      {currentStep > 0 && (
        <TeButton
          slot="tertiary"
          text={t('step.previous', { ns: 'common' })}
          variant="neutral"
          teclick={() => onPreviousStep(currentStep - 1)}
          size="s"
          disabled={isPending}
        />
      )}
      {/* Create service agreement with customer button */}
      {currentStep === StepEnum.ReviewAgreement && (
        <TeButton
          text={
            creationType === AgreementCreationType.New
              ? t('customers.createModal.title')
              : t('customers.add')
          }
          variant="primary"
          slot="primary"
          teclick={onSubmit}
          size="s"
          disabled={isPending || isNextStepDisabled}
          loading={isPending}
        />
      )}
      {/* Next step button */}
      {currentStep !== totalSteps - 1 && (
        <TeButton
          slot="primary"
          text={t('step.next', { ns: 'common' })}
          variant="primary"
          teclick={() => onNextStep(currentStep + 1)}
          size="s"
          disabled={isPending || isNextStepDisabled}
          loading={isPending}
        />
      )}
    </>
  );
}

export { CreateCustomerStepActions };
